module.exports = __webpack_public_path__ + "static/img/357_phase_function_Paper_PointsHejduk_Prediction.bd67aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/357_phase_function_Paper_PointsHejduk_Prediction.png
// module id = L1Rx
// module chunks = 0